const actions = {
  async getAll({ rootState }, { noteUuid, uuidsOnly }) {
    return rootState.storageProvider.getImages({ noteUuid, uuidsOnly });
  },

  async getAllUuids({ rootState }, { noteUuid }) {
    return rootState.storageProvider.getImageUuids(noteUuid);
  },

  async get({ rootState }, { uuid }) {
    return rootState.storageProvider.getImage(uuid);
  },

  async create({ rootState }, { uuid, data }) {
    const noteUuid = rootState.notes.current.uuid;
    return rootState.storageProvider.createImage(noteUuid, data, uuid);
  },
};

export default {
  namespaced: true,
  actions,
};
